import React, { Component } from 'react'
import { Table, Spin } from 'antd'

class Overview extends Component {
  getColumns = () => {
    return [
      {
        title: 'Entity',
        dataIndex: 'entity'
      },
      {
        title: 'Total Added During Time Period',
        dataIndex: 'total'
      }
    ]
  }

  getData = () => {
    const { overviewData } = this.props
    return [
      {
        key: '1',
        entity: 'Contacts',
        total: overviewData.contacts
      },
      {
        key: '2',
        entity: 'Companies',
        total: overviewData.companies
      },
      {
        key: '3',
        entity: 'Leads',
        total: overviewData.leads
      },
      {
        key: '4',
        entity: 'Jobs',
        total: overviewData.jobs
      },
      {
        key: '5',
        entity: 'Estimates',
        total: overviewData.estimates
      },
      {
        key: '6',
        entity: 'Proposals',
        total: overviewData.proposals
      },
      {
        key: '7',
        entity: 'Contracts',
        total: overviewData.contracts
      }
    ]
  }

  render() {
    const { loadingOverview, overviewData } = this.props
    return (
      <div>
        {loadingOverview && !overviewData && <Spin />}
        {!loadingOverview &&
          overviewData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default Overview



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/Overview.js